/* eslint-disable consistent-return */
import apiService from 'src/enviroment';

const getIpc = async () => {
  const response = await apiService.get('/indicadores/maestros/ipc/');
  try {
    if (response.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const updateIpc = async (params) => {
  const body = {
    variacion: params.variacion,
    indice: params.indice,
  };
  const { status, data } = await apiService.post(
    '/indicadores/maestros/ipc/',
    body,
  );
  try {
    if (status === 200 && data.success === 1) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const getICC = async () => {
  const { status, data } = await apiService.get('/indicadores/maestros/icc/');
  try {
    if (status === 200 && data.success === 1) {
      return data.data;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const updateICC = async (params) => {
  const body = {
    valor: params.valor,
  };
  const { status, data } = await apiService.post(
    '/indicadores/maestros/icc/',
    body,
  );
  try {
    if (status === 200 && data.success === 1) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const ipciccService = {
  getIpc, updateIpc, getICC, updateICC,
};

export default ipciccService;
